// Content for the Home page hero + committees section.
// The committee cards themselves come from the shared `committees` module.

// The hero slogan is set as two display lines; the second carries the accent color.
export const heroSloganLead = "Money for Detroit";
export const heroSloganAccent = "Not for war";

export const heroTagline =
  "United in our commitment to oppose all U.S. wars, interventions, and sanctions.";

export const heroCtaLabel = "Join DAWC";

export const heroSecondaryCtaLabel = "Our demands";

// The heading is a sentence the three subcommittee names finish: "Building
// community power through / art / education / action."
export const committeesHeading = "Building community power through";

export const committeesCtaLabel = "Explore our subcommittees";
